import { PortalSettings } from "@edl-development/edl-common";
import { EdlRegistrationToken } from "./edl-registration-token.model";

export class ValidatedRegistrationToken extends EdlRegistrationToken {
    constructor() {
        super();
        this.PortalID = null;
        this.PortalName = null;
        this.Token = null;
    }
    PortalSettings: PortalSettings;
    PortalName: string;
}